import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgUpload(props: RootSvgProps) {
  return (
    <RootSvg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="32" r="32" fill="#E5E5E5" />
      <path
        d="M19.8866 29.7143C18.9997 29.7143 18.5517 28.6453 19.1738 28.013L31.2633 15.7246C31.6551 15.3263 32.2972 15.3263 32.689 15.7246L44.7786 28.013C45.4006 28.6453 44.9527 29.7143 44.0657 29.7143H38.3095C37.7572 29.7143 37.3095 30.162 37.3095 30.7143V46C37.3095 46.5523 36.8618 47 36.3095 47H27.6429C27.0906 47 26.6429 46.5523 26.6429 46V30.7143C26.6429 30.162 26.1951 29.7143 25.6429 29.7143H19.8866Z"
        fill="white"
      />
    </RootSvg>
  );
}
